import CryptoJS from 'crypto-js';
import valid from 'card-validator';
import yup from 'validation';

const currentYear = new Date().getFullYear();

const months = Array.from({ length: 12 }, (_, i) =>
  i >= 9 ? i + 1 : `0${i + 1}`
);

const years = Array.from({ length: 8 }, (_, i) =>
  (currentYear + i).toString().slice(2)
);

const CryptoJSAesJson = {
  stringify: function (cipherParams) {
    const j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
    if (cipherParams.iv) j.iv = cipherParams.iv.toString();
    if (cipherParams.salt) j.s = cipherParams.salt.toString();
    return JSON.stringify(j).replace(/\s/g, '');
  },
  parse: function (jsonStr) {
    const j = JSON.parse(jsonStr);
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(j.ct),
    });
    if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
    if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
    return cipherParams;
  },
};

const browserData = {
  acceptHeader: 'application/json',
  userAgent: navigator.userAgent,
  language: navigator.language,
  timezone: new Date().getTimezoneOffset().toString(),
  colorDepth: screen.colorDepth,
  screen: {
    height: screen.height.toString(),
    width: screen.width.toString(),
  },
  javaScriptEnabled: true,
  javaEnabled: navigator.javaEnabled(),
};

const schema = yup.object().shape({
  name: yup.string().required().min(3).alphaApostrophe(),
  cardNumber: yup
    .string()
    .required()
    .min(16)
    .test(
      'credit_card',
      'Credit Card number is invalid', //validation message
      (value) => valid.number(value).isValid
    ),
  expirationMonth: yup.number().required(),
  expirationYear: yup.number().required(),
  cvv: yup.string().required().min(3),
});

export { months, years, CryptoJSAesJson, browserData, schema };
